import { IResolvedCardItemContent } from '@/src/utils/collections/cards.mapper';

interface IProps {
  cardContent?: IResolvedCardItemContent;
}

export const CardContent = ({ cardContent }: IProps) => {
  if (cardContent?.type === 'text') {
    return <div className={'mb-6 mt-3 text-lg'}>{cardContent.text}</div>;
  }

  return (
    <div
      className={'mb-6 mt-3 grid columns-2 grid-cols-1 gap-6 lg:grid-cols-2'}
    >
      {cardContent?.blocks.map((block, i) => (
        <div
          className={'rounded-[20px] p-6 shadow-2xl'}
          key={`${block.title}` + i}
        >
          <div className={'mb-1 text-[24px]'}>{block.title}</div>
          <div className={'text-[18px] leading-[21px]'}>{block.text}</div>
        </div>
      ))}
    </div>
  );
};
